import React, { Component } from 'react';
import { navigateTo } from '../utils/navigation';

var config = process.env;

class MercadoLibreSettingsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isSubmitting: false,
            branches: [],
            mode: 'global',
            enabled: '0',
            branchId: '0',
            syncBranchId: '0',
            clientId: '',
            clientSecret: '',
            accessToken: '',
            refreshToken: '',
            expiresIn: '',
            sellerUserId: '',
            showClientSecret: false,
            showAccessToken: false,
            showRefreshToken: false,
        };
    }

    // La última foto del barrido: instantánea (no consulta ML), para no demorar la pantalla.
    renderSensitiveInput = ({ label, value, onChange, isVisible, onToggle, placeholder = '' }) => (
        <div className="form-group">
            <label>{label}</label>
            <div className="input-group">
                <input
                    type={isVisible ? 'text' : 'password'}
                    className="form-control"
                    value={value}
                    placeholder={placeholder}
                    onChange={onChange}
                    autoComplete="off"
                />
                <div className="input-group-append">
                    <button
                        type="button"
                        className="btn btn-outline-secondary d-flex align-items-center"
                        onClick={onToggle}
                        aria-label={isVisible ? `Ocultar ${label}` : `Mostrar ${label}`}
                    >
                        <i className="material-icons" style={{ fontSize: '1.1rem' }}>
                            {isVisible ? 'visibility_off' : 'visibility'}
                        </i>
                    </button>
                </div>
            </div>
        </div>
    )

    componentWillUnmount() {
        this.desmontado = true;
    }

    componentDidMount() {
        this.loadData();
    }

    getSelectedBranchId = () => String(this.state.mode === 'branch' ? this.state.branchId : '0')

    getAuthorizationUrl = () => {
        const clientId = String(this.state.clientId || '').trim();
        if (!clientId) {
            return '';
        }

        const state = `${this.state.mode}:${this.getSelectedBranchId()}`;
        return `https://auth.mercadolibre.com.uy/authorization?response_type=code&client_id=${encodeURIComponent(clientId)}&redirect_uri=${encodeURIComponent(config.REACT_APP_REDIRECT_MP)}&state=${encodeURIComponent(state)}`;
    }

    applySettingsData = (settingsData = {}, nextState = {}) => {
        this.setState({
            enabled: String(settingsData.enabled || '0'),
            mode: settingsData.mode || nextState.mode || this.state.mode,
            branchId: String(settingsData.branchId != null ? settingsData.branchId : (nextState.branchId != null ? nextState.branchId : this.state.branchId || '0')),
            syncBranchId: String(settingsData.syncBranchId != null ? settingsData.syncBranchId : (this.state.syncBranchId || '0')),
            clientId: settingsData.clientId || '',
            clientSecret: settingsData.clientSecret || '',
            accessToken: settingsData.accessToken || '',
            refreshToken: settingsData.refreshToken || '',
            expiresIn: settingsData.expiresIn || '',
            sellerUserId: settingsData.sellerUserId || '',
            ...nextState,
        });
    }

    loadData = async (options = {}) => {
        const nextMode = options.mode || this.state.mode || 'global';
        const nextBranchId = options.branchId != null ? String(options.branchId) : this.state.branchId || '0';
        this.setState({ loading: true });

        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
        };

        try {
            const [settingsResponse, branchesResponse] = await Promise.all([
                fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}configuration/settings/mercadolibre?mode=${nextMode}${nextMode === 'branch' ? `&branchId=${nextBranchId}` : ''}`, request),
                fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch`, request),
            ]);

            const settingsData = await settingsResponse.json();
            const branchesData = await branchesResponse.json();

            if (settingsData.error > 0) {
                alert(settingsData.message);
                return;
            }

            if (branchesData.error > 0) {
                alert(branchesData.message);
                return;
            }

            this.applySettingsData(settingsData.data || {}, {
                branches: branchesData.data || [],
                loading: false,
                mode: nextMode,
                branchId: nextBranchId,
            });
        } catch (error) {
            this.setState({ loading: false });
        }
    }

    onSubmit = async () => {
        this.setState({ isSubmitting: true });

        try {
            const response = await fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}configuration/settings/mercadolibre`, {
                method: 'PUT',
                headers: {
                    'access-token': localStorage.getItem('token'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    mode: this.state.mode,
                    enabled: this.state.enabled,
                    branchId: Number(this.state.branchId || 0),
                    syncBranchId: Number(this.state.syncBranchId || 0),
                    clientId: this.state.clientId,
                    clientSecret: this.state.clientSecret,
                    accessToken: this.state.accessToken,
                    refreshToken: this.state.refreshToken,
                    expiresIn: this.state.expiresIn,
                    sellerUserId: this.state.sellerUserId,
                }),
            });

            const data = await response.json();
            if (data.error > 0) {
                alert(data.message);
                return false;
            }

            this.applySettingsData(data.data || {}, {
                mode: this.state.mode,
                branchId: this.state.branchId,
            });
            return true;
        } finally {
            this.setState({ isSubmitting: false });
        }
    }

    handleModeChange = (event) => {
        const mode = event.target.value === 'branch' ? 'branch' : 'global';
        this.setState({ mode }, () => {
            this.loadData({ mode, branchId: this.state.branchId || '0' });
        });
    }

    handleBranchAccountChange = (event) => {
        const branchId = event.target.value;
        this.setState({ branchId }, () => {
            this.loadData({ mode: 'branch', branchId });
        });
    }

    handleRefreshToken = async () => {
        if (this.state.isSubmitting) {
            return;
        }

        if (!this.state.clientId || !this.state.clientSecret) {
            alert('Completá Client ID y Client Secret antes de actualizar el token.');
            return;
        }

        const didSave = await this.onSubmit();
        if (!didSave) {
            return;
        }
        const authorizationUrl = this.getAuthorizationUrl();
        if (!authorizationUrl) {
            return;
        }

        navigateTo(authorizationUrl);
    }

    render() {
        const isBranchMode = this.state.mode === 'branch';
        const authorizationUrl = this.getAuthorizationUrl();

        return (
            <div className="card">
                <div className="d-flex justify-content-between align-items-center border-bottom" style={{ padding: '1rem 1.5rem' }}>
                    <span className="text-muted" style={{ fontSize: '0.95rem' }}>
                        Configurá MercadoLibre con una cuenta global o con una cuenta distinta por sucursal.
                    </span>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.loadData()}>
                        Recargar
                    </button>
                </div>
                <div className="card-body">
                    {this.state.loading ? (
                        <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                            <div className="loader"></div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="form-group">
                                    <label>Modo</label>
                                    <select
                                        className="custom-select"
                                        value={this.state.mode}
                                        onChange={this.handleModeChange}
                                    >
                                        <option value="global">Global</option>
                                        <option value="branch">Por sucursal</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form-group">
                                    <label>Estado</label>
                                    <select
                                        className="custom-select"
                                        value={this.state.enabled}
                                        onChange={(event) => this.setState({ enabled: event.target.value })}
                                    >
                                        <option value="0">Deshabilitado</option>
                                        <option value="1">Habilitado</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form-group">
                                    <label>{isBranchMode ? 'Sucursal de la cuenta' : 'Sucursal de sincronización'}</label>
                                    <select
                                        className="custom-select"
                                        value={isBranchMode ? this.state.branchId : this.state.syncBranchId}
                                        onChange={isBranchMode ? this.handleBranchAccountChange : (event) => this.setState({ syncBranchId: event.target.value })}
                                    >
                                        {!isBranchMode && <option value="0">Global (usa sucursal principal)</option>}
                                        {this.state.branches.map((branch) => (
                                            <option key={branch.id} value={branch.id}>{branch.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label>Client ID</label>
                                    <input className="form-control" value={this.state.clientId} onChange={(event) => this.setState({ clientId: event.target.value })} />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                {this.renderSensitiveInput({
                                    label: 'Client Secret',
                                    value: this.state.clientSecret,
                                    onChange: (event) => this.setState({ clientSecret: event.target.value }),
                                    isVisible: this.state.showClientSecret,
                                    onToggle: () => this.setState((prevState) => ({ showClientSecret: !prevState.showClientSecret })),
                                })}
                            </div>
                            <div className="col-lg-6">
                                {this.renderSensitiveInput({
                                    label: 'Access Token',
                                    value: this.state.accessToken,
                                    onChange: (event) => this.setState({ accessToken: event.target.value }),
                                    isVisible: this.state.showAccessToken,
                                    onToggle: () => this.setState((prevState) => ({ showAccessToken: !prevState.showAccessToken })),
                                })}
                            </div>
                            <div className="col-lg-6">
                                {this.renderSensitiveInput({
                                    label: 'Refresh Token',
                                    value: this.state.refreshToken,
                                    onChange: (event) => this.setState({ refreshToken: event.target.value }),
                                    isVisible: this.state.showRefreshToken,
                                    onToggle: () => this.setState((prevState) => ({ showRefreshToken: !prevState.showRefreshToken })),
                                })}
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group mb-0">
                                    <label>Expira en</label>
                                    <input className="form-control" value={this.state.expiresIn} onChange={(event) => this.setState({ expiresIn: event.target.value })} />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="form-group mb-0">
                                    <label className="d-flex align-items-center" style={{ gap: '0.4rem' }}>
                                        <span>Seller User ID</span>
                                        <span
                                            title="Identifica la cuenta de MercadoLibre que envía la notificación. Se usa para elegir las credenciales correctas y descontar stock en la sucursal correspondiente."
                                            style={{ display: 'inline-flex', color: '#8a94a6', cursor: 'help' }}
                                        >
                                            <i className="material-icons" style={{ fontSize: '1rem' }}>info_outline</i>
                                        </span>
                                    </label>
                                    <div className="d-flex align-items-center" style={{ gap: '0.75rem' }}>
                                        <input className="form-control" value={this.state.sellerUserId} onChange={(event) => this.setState({ sellerUserId: event.target.value })} />
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary flex-shrink-0"
                                            onClick={this.handleRefreshToken}
                                            disabled={this.state.isSubmitting || !authorizationUrl}
                                            style={{ whiteSpace: 'nowrap' }}
                                        >
                                            Actualizar token MP
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mt-4 d-flex flex-wrap" style={{ gap: '0.75rem' }}>
                                <button className="btn btn-primary" onClick={this.onSubmit} disabled={this.state.isSubmitting}>
                                    Guardar configuración
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default MercadoLibreSettingsComponent;
